import { render, staticRenderFns } from "./HoldingShares.vue?vue&type=template&id=1542b90d&scoped=true&"
import script from "./HoldingShares.vue?vue&type=script&lang=js&"
export * from "./HoldingShares.vue?vue&type=script&lang=js&"
import style0 from "./HoldingShares.vue?vue&type=style&index=0&id=1542b90d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1542b90d",
  null
  
)

export default component.exports